<div class="container mt-3" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
  <h3>
    {{ data.details.title.split(" ")[0] }}
    <span>{{ data.details.title.split(" ").slice(1).join(" ") }}</span>
  </h3>

  <div class="row justify-content-between">
    <div
      class="col-12 col-sm-6 col-md-4"
      *ngFor="let mainservice of data.details.services"
    >
      <!-- Use anchor tag for navigation -->

      <a
        *ngIf="!data.details.isDetails"
        class="card-content card-blue"
        [ngStyle]="{
          'text-decoration': 'none',
          color: 'inherit',
          display: 'block'
        }"
      >
        <div class="card-img" *ngIf="mainservice.imageIconPath">
          <fa-icon [icon]="icons[mainservice.imageIconPath]"></fa-icon>
          <i class=" {{ mainservice.imageIconPath }}"></i>
        </div>
        <div class="card-title" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
          {{ mainservice.titleTr }}
        </div>
        <div class="card-description">
          <div [dir]="language == 'ar' ? 'rtl' : 'ltr'">
            {{ mainservice.summary }}
          </div>
        </div>
      </a>
      <a
        *ngIf="data.details.isDetails"
        [href]="getDetailsUrl(mainservice)"
        class="card-content card-blue pointer"
        [ngStyle]="{
          'text-decoration': 'none',
          color: 'inherit',
          display: 'block'
        }"
      >
        <div class="card-img" *ngIf="mainservice.imageIconPath">
          <fa-icon [icon]="icons[mainservice.imageIconPath]"></fa-icon>
        </div>
        <div class="card-title" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
          {{ mainservice.titleTr }}
        </div>
        <div class="card-description">
          <div [dir]="language == 'ar' ? 'rtl' : 'ltr'">
            {{ mainservice.summary }}
          </div>
        </div>
      </a>
    </div>
  </div>
</div>
